import _ from 'lodash'

// eslint-disable-next-line
export const fullName = person => `${_.upperFirst(_.lowerCase(person.first_name))} ${_.upperFirst(_.lowerCase(person.last_name))}`
